import {
  RadioGroup as HeroUiRadioGroup,
  type RadioGroupProps,
} from '@heroui/radio'
import { createInput } from './input-factory'

export * from '@heroui/radio'

const RadioGroup = ({
  onSelectValue,
  onValueChange,
  ...rest
}: RadioGroupProps & {
  onSelectValue?: (value: string) => void
}) => {
  return (
    <HeroUiRadioGroup
      {...rest}
      onValueChange={value => {
        onValueChange?.(value)
        onSelectValue?.(value)
      }}
    />
  )
}

export const FormRadioGroup = createInput(RadioGroup, ['form'])
